// Base configuration
export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_URL || 'https://api.example.com',
  TIMEOUT: 20000,
};

export const API_URL = {
  BASE_AUTH: import.meta.env.VITE_BASE_AUTH || 'https://auth-dev.biglocal.in',
  BASE_USER: import.meta.env.VITE_BASE_USER || 'https://user-dev.biglocal.in',
  BASE_VENDOR: import.meta.env.VITE_BASE_VENDOR || 'https://vendor-dev.biglocal.in',
  BASE_ORDER: import.meta.env.VITE_BASE_ORDER || 'https://order-dev.biglocal.in',
  BASE_PRODUCT: import.meta.env.VITE_BASE_PRODUCT || 'https://product-dev.biglocal.in',
  BASE_NOTTFICATION:
    import.meta.env.VITE_BASE_NOTTFICATION || 'https://notification-dev.biglocal.in',
};

export const USER_ROLES = {
  VENDOR: 'Vendor',
  USER: 'User',
};

// API Path Prefixes
export const API_PATHS = {
  SUBZIWALE: '/rest/subziwale/api/v1',
  ADMIN: '/rest/admin/dashboard/api/v1',
};

// API Endpoints
export const API_ENDPOINTS = {
  // Orders
  ORDERS: {
    BASE: `${API_PATHS.SUBZIWALE}/order`,
    VENDOR: `${API_PATHS.SUBZIWALE}/orders/vendor`,
    DETAILS: `${API_PATHS.SUBZIWALE}/order/details`,
    STATUS: `${API_PATHS.SUBZIWALE}/order/status`,
  },

  // Categories
  CATEGORIES: `${API_PATHS.SUBZIWALE}/categories`,

  // Products
  PRODUCTS: {
    BASE: `${API_PATHS.SUBZIWALE}/products`,
    VENDOR: `${API_PATHS.SUBZIWALE}/products/vendor`,
  },

  // Vendor
  VENDOR: {
    BASE: `${API_PATHS.SUBZIWALE}/vendor`,
    STATUS: `${API_PATHS.ADMIN}/vendor/status`,
  },

  // User
  USER: `${API_PATHS.SUBZIWALE}/user`,

  // Address
  ADDRESS: {
    BASE: `${API_PATHS.SUBZIWALE}/address`,
    LIST: `${API_PATHS.SUBZIWALE}/addresses`,
  },

  // Notifications (Push Notifications)
  NOTIFICATIONS: {
    REGISTER: '/rest/big-local/api/v1/notification/device/register',
    UNREGISTER: '/rest/big-local/api/v1/notification/device/unregister',
  },
};

// HTTP Methods
export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
};

// Header Keys
export const HEADER_KEYS = {
  VENDOR_ID: 'X-Vendor-Id',
  VENDOR_ID_ALT: 'X-VENDOR-ID', // Alternative header key
  USER_ID: 'X-User-Id',
  USER_ROLE: 'X-USER-ROLE',
  CONTENT_TYPE: 'Content-Type',
  AUTHORIZATION: 'Authorization',
  SESSION_TOKEN: 'sessionToken',
};

// Order Status
export const ORDER_STATUS = {
  PENDING: 'Pending',
  CONFIRMED: 'Confirmed',
  PROCESSING: 'Processing',
  SHIPPED: 'Shipped',
  DELIVERED: 'Delivered',
  CANCELLED: 'Cancelled',
  RESCHEDULED: 'Rescheduled',
  OUT_FOR_DELIVERY: 'OutForDelivery',
};

// Vendor Status
export const VENDOR_STATUS = {
  APPROVED: 'Approved',
  OUT_OF_STATION: 'OutOfStation',
  PENDING: 'Pending',
  REJECTED: 'Rejected',
};

// User Types
export const USER_TYPES = {
  VENDOR: 'vendor',
};

// UI Constants
export const UI_CONSTANTS = {
  MAX_CONTAINER_WIDTH: 'max-w-md',
  GRID_COLS_MOBILE: 'grid-cols-2',
  STICKY_TOP_OFFSET: 'top-14',
  SUBCATEGORY_SIDEBAR_WIDTH: 'w-20',
  BOTTOM_PADDING: 'pb-20',
};

// Image Constants
export const IMAGE_CONSTANTS = {
  PLACEHOLDER_SVG: '/placeholder.svg',
  DEFAULT_SHOP_IMAGE: '/placeholder.svg',
  CATEGORY_IMAGE_PATH: (categoryName) => `/${categoryName}.webp`,
  DEFAULT_LOGO: '/images/biglocallogo3.webp',
};

// Animation and Transition Classes
export const ANIMATION_CLASSES = {
  SLIDE_DOWN: 'animate-slideDown',
  TRANSITION_ALL: 'transition-all duration-300',
  TRANSITION_COLORS: 'transition-colors',
  SMOOTH_SCROLL: 'scroll-smooth',
};

// Color Schemes
export const COLOR_SCHEMES = {
  PRIMARY_BG: '#FDFFF2',
  ORANGE_ACCENT: '#e47b2b',
  BLUE_ACCENT: '#159FD1',
  GREEN_ACCENT: '#16B548',
  OFFLINE_RED: 'bg-red-500',
  ONLINE_GREEN: 'bg-green-500',
};

// Component States
export const COMPONENT_STATES = {
  LOADING: 'loading',
  ERROR: 'error',
  SUCCESS: 'success',
  EMPTY: 'empty',
  OFFLINE: 'offline',
  ONLINE: 'online',
};

// Swipe Directions
export const SWIPE_DIRECTIONS = {
  LEFT: 'Left',
  RIGHT: 'Right',
  UP: 'Up',
  DOWN: 'Down',
};

export const STORAGE_KEYS = {
  SESSION_TOKEN: 'sessionToken',
  REFRESH_TOKEN: 'refreshToken',
  SELECTED_VENDOR: 'selectedVendor',
  CONTACT_NO: 'contactNo',
  VENDOR_ID: 'vendorId',
  FCM_TOKEN: 'fcmToken',
  PWA_PROMPT_DISMISSED: 'pwaPromptDismissed',
  ACTIVE_CATEGORY_ID: 'dashboard_active_category_id',
  ACTIVE_SUB_CATEGORY_ID: 'dashboard_active_sub_category_id',
};

// SEO Constants
export const SEO_CONSTANTS = {
  DEFAULT_TITLE: "Vendor Dashboard - Let's make Local Big",
  DEFAULT_DESCRIPTION:
    'Manage your store products, inventory, and categories. Vendor dashboard for local businesses.',
  CANONICAL_URL: 'https://www.biglocal.in/',
  OG_IMAGE: '/images/biglocallogo3.webp',
};

// Scroll Behavior
export const SCROLL_BEHAVIOR = {
  SMOOTH: 'smooth',
  AUTO: 'auto',
  INSTANT: 'instant',
};

// Grid and Layout
export const LAYOUT_CONSTANTS = {
  SIDEBAR_STICKY_TOP: 'top-44',
  MAX_HEIGHT_SIDEBAR: 'max-h-[calc(100vh-11rem)]',
  PRODUCT_GRID_GAP: 'gap-4',
  CONTAINER_PADDING: 'px-2 py-2',
};

// Default Values
export const DEFAULTS = {
  PAGE_SIZE: 10,
  PAGE_NUMBER: 0,
  TIMEOUT: 5000,
  RETRY_ATTEMPTS: 3,
};

// Query Parameters
export const QUERY_PARAMS = {
  STATUS: 'status',
  PAGE_NO: 'pageNo',
  CATEGORY: 'category',
  VENDOR_ID: 'vendorId',
  ORDER_ID: 'orderId',
  INTEGER: 'Integer',
};

// Content Types
export const CONTENT_TYPES = {
  JSON: 'application/json',
  FORM_DATA: 'multipart/form-data',
  URL_ENCODED: 'application/x-www-form-urlencoded',
};

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error occurred',
  UNAUTHORIZED: 'Unauthorized access',
  FORBIDDEN: 'Access forbidden',
  NOT_FOUND: 'Resource not found',
  SERVER_ERROR: 'Internal server error',
  TIMEOUT: 'Request timeout',
  UNKNOWN: 'An unknown error occurred',
};

// Success Messages
export const SUCCESS_MESSAGES = {
  ORDER_UPDATED: 'Order updated successfully',
  PROFILE_UPDATED: 'Profile updated successfully',
  ADDRESS_CREATED: 'Address created successfully',
  ADDRESS_UPDATED: 'Address updated successfully',
  ADDRESS_DELETED: 'Address deleted successfully',
  VENDOR_UPDATED: 'Vendor information updated successfully',
};

// Time Slots
export const TIME_SLOTS = [
  '10:00-12:00',
  '12:00-14:00',
  '14:00-16:00',
  '16:00-18:00',
  '18:00-20:00',
];

// Cancel Reasons
export const CANCEL_REASONS = [
  'Incorrect address',
  'Customer not responding',
  'Denied delivery',
  'Unavailable',
  'Other',
];

// Order Status Options for Filtering
export const ORDER_STATUS_OPTIONS = [
  { value: 'All', color: 'bg-gray-100 text-gray-800' },
  { value: 'Pending', color: 'bg-yellow-100 text-yellow-800' },
  { value: 'Paid', color: 'bg-green-100 text-green-800' },
  { value: 'Completed', color: 'bg-blue-100 text-blue-800' },
  { value: 'Cancelled', color: 'bg-red-100 text-red-800' },
];

// Order Edit Mode
export const EDIT_MODE = {
  VIEW: 'view',
  EDIT: 'edit',
};

// Build full URL helper
export const buildUrl = (endpoint, queryParams = {}) => {
  const url = new URL(`${API_CONFIG.BASE_URL}${endpoint}`);
  Object.entries(queryParams).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      url.searchParams.append(key, value);
    }
  });
  return url.toString();
};

// Build headers helper
export const buildHeaders = (additionalHeaders = {}) => {
  return {
    [HEADER_KEYS.CONTENT_TYPE]: CONTENT_TYPES.JSON,
    ...additionalHeaders,
  };
};

// Build vendor headers helper
export const buildVendorHeaders = (vendorId, additionalHeaders = {}) => {
  return {
    [HEADER_KEYS.VENDOR_ID]: vendorId,
    [HEADER_KEYS.VENDOR_ID_ALT]: vendorId,
    ...buildHeaders(additionalHeaders),
  };
};

// Build user headers helper
export const buildUserHeaders = (userId, additionalHeaders = {}) => {
  return {
    [HEADER_KEYS.USER_ID]: userId,
    ...buildHeaders(additionalHeaders),
  };
};

export const URLS = {
  SELLER: import.meta.env.VITE_SELLER_URL,
  USER: import.meta.env.VITE_USER_URL,
  REGISTER: import.meta.env.VITE_REGISTER_URL,
  ABOUT: import.meta.env.VITE_ABOUT_URL,
};

// Google Maps Configuration
export const GOOGLE_MAPS_CONFIG = {
  API_KEY: import.meta.env.VITE_PUBLIC_GOOGLE_MAPS_API_KEY,
  EMBED_URL: 'https://www.google.com/maps/embed/v1/place',
  SEARCH_URL: 'https://www.google.com/maps/search/?api=1',
  DEFAULT_ZOOM: 15,
};

export const ORDER_ATTRIBUTE_KEYS = {
  DELIVERY_CHARGE: 'Delivery Charge',
  DELIVERY_METHOD: 'Delivery Method',
  DELIVERY_TIME: 'Delivery Time',
  ORDER_DATE: 'Order Date',
  DELIVERED_ON: 'Delivered On',
  PAID_ON: 'Paid On',
  RESCHEDULED_ON: 'Rescheduled On',
  APPROVED_ON: 'Approved On',
  OUT_FOR_DELIVERY_ON: 'Out For Delivery On',
  CANCELLED_ON: 'Cancelled On',
  IS_SERVICE: 'Is Service',
  SUBSCRIBED_ON: 'Subscribed On',
  PAYMENT_METHOD: 'Payment Method',
  TABLE_NUMBER: 'Table Number',
  CANCELLED_BY: 'Cancelled By',
  SERVICE_PICKUP_TIME: 'Service Pickup Time',
  IS_DINE_IN: 'Is Dine In',
  DELIVERY_SLOTS: 'Delivery Slots',
  SHOP_TIMING: 'Shop Timing',
  WEEKLY_OFF_DAY: 'Weekly Off Day',
  PLATFORM_FEE: 'Platform Fee',
  EVENT_DATE: 'Event Date',
};

export const PAYMENT_MODE = {
  PAY_ON_DELIVERY: 'Pay On Delivery',
};

export const DELIVERY_PREPARATION_TIMES = [
  { value: '0.5', label: '30 Minutes' },
  { value: '1', label: '1 Hour' },
  { value: '2', label: '2 Hours' },
  { value: '3', label: '3 Hours' },
  { value: '4', label: '4 Hours' },
  { value: '5', label: '5 Hours' },
  { value: '6', label: '6 Hours' },
];

export const DELIVERY_SLOT_INTERVALS = [
  { value: '1', label: '1 Hour' },
  { value: '2', label: '2 Hours' },
  { value: '3', label: '3 Hours' },
  { value: '4', label: '4 Hours' },
  { value: '5', label: '5 Hours' },
  { value: '6', label: '6 Hours' },
];

export const ATTRIBUTE_KEYS = {
  DELIVERY_CHARGES: 'deliveryCharges',
  MINIMUM_ORDER: 'minimumOrder',
  SHOP_TIMING: 'shopTiming',
  OFF_HOURS: 'offHours',
  WEEKLY_OFF_DAY: 'weeklyOffDay',
  IS_FRANCHISE: 'isFranchise',
  FRANCHISE_NAME: 'franchiseName',
  BUSSINESS_TYPE: 'bussinessType',
  PRODUCT_DELIVERY_TYPE: 'productDeliveryType',
  SERVICE_DELIVERY_TYPE: 'serviceDeliveryType',
  SUBSCRIPTION_DELIVERY_TYPE: 'subscriptionDeliveryType',
  DELIVERY_METHOD: 'deliveryMethod',
  DELIVERY_PREPARATION_TIME: 'deliveryPreparationTime',
  DELIVERY_SLOTS: 'deliverySlots',
  IS_EXPRESS_DELIVERY: 'isExpressDelivery',
  ESTABLISHED_YEAR: 'establishedYear',
  GST_NO: 'gstNo',
  PAN_NO: 'panNo',
  CERTIFICATIONS: 'certifications',
  UDYAM_NO: 'udyamNo',
  MIN_DAYS: 'minDays',
  MAX_DAYS: 'maxDays',
  CUSTOM_IMAGE: 'customImage',
  YOUTUBE: 'youtube',
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  TWITTER: 'Twitter',
  WEBSITE: 'website',
  TAGLINE: 'tagline',
  ABOUT_US: 'aboutUs',
  VENDOR_UPI_ID: 'VendorUpiId',
  PAYMENT_METHOD: 'paymentMethod',
  LOGISTICS_TYPE: 'logisticsType',
  EVENT_DATE: 'eventDate',
  EVENT_VENUE: 'eventVenue',
  EVENT_DETAILS: 'eventDetails',
  ANNOUNCEMENT: 'announcement',
  IS_EVENT_VENDOR: 'isEventVendor',
};

export const SEVEN_DAYS_OPEN_VALUE = '7 Days Open';

export const ORDER_STATUS_KEYS = {
  PENDING: 'Pending',
  ACCEPTED: 'Accepted',
  RESCHEDULED: 'Rescheduled',
  CANCELLED: 'Cancelled',
  DELIVERED: 'Delivered',
  PAID: 'Paid',
  OUT_FOR_DELIVERY: 'OutForDelivery',
};

// Status configuration for badges
export const STATUS_CONFIG = {
  accepted: {
    bg: 'bg-purple-100',
    text: 'text-purple-800',
    dot: 'bg-purple-500',
    label: 'Accepted',
  },
  outfordelivery: {
    bg: 'bg-violet-100',
    text: 'text-violet-800',
    dot: 'bg-violet-500',
    label: 'Out For Delivery',
  },
  delivered: {
    bg: 'bg-green-100',
    text: 'text-green-800',
    dot: 'bg-green-500',
    label: 'Delivered',
  },
  pending: {
    bg: 'bg-yellow-100',
    text: 'text-yellow-800',
    dot: 'bg-yellow-500',
    label: 'Pending',
  },
  rescheduled: {
    bg: 'bg-blue-100',
    text: 'text-blue-800',
    dot: 'bg-blue-500',
    label: 'Rescheduled',
  },
  cancelled: {
    bg: 'bg-red-100',
    text: 'text-red-800',
    dot: 'bg-red-500',
    label: 'Cancelled',
  },
  paid: {
    bg: 'bg-orange-100',
    text: 'text-orange-800',
    dot: 'bg-orange-500',
    label: 'Paid',
  },
};

// Helper function to get status badge configuration
export const getStatusBadge = (status) => {
  if (!status) return STATUS_CONFIG.pending;

  const normalizedStatus = status.toLowerCase().replace(/\s+/g, '');
  return STATUS_CONFIG[normalizedStatus] || STATUS_CONFIG.pending;
};

// Push Notification Types
export const NOTIFICATION_TYPES = {
  ORDER_PLACED: 'ORDER_PLACED',
  ORDER_STATUS_UPDATE: 'ORDER_STATUS_UPDATE',
  ORDER_CANCELLED: 'ORDER_CANCELLED',
  ORDER_DELIVERED: 'ORDER_DELIVERED',
  PAYMENT_RECEIVED: 'PAYMENT_RECEIVED',
  VENDOR_MESSAGE: 'VENDOR_MESSAGE',
};

// Push Notification Platforms
export const NOTIFICATION_PLATFORMS = {
  WEB: 'WEB',
  ANDROID: 'ANDROID',
  IOS: 'IOS',
};

// Firebase Configuration
export const FIREBASE_CONFIG = {
  VAPID_KEY: import.meta.env.VITE_VAPID_KEY,
  PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'subziwale-11c22',
};
